import React from "react"; 

import Contactimg1 from "../../new_Images/OtherComponents/17.png"; 

import joincomunity from "../../new_Images/OtherComponents/BottomBanner.png"; 

import "../../App.css"; 

import { Button } from "primereact/button";

  

import { Link } from "react-router-dom"; 


import CommanComponentContact from "./CommanComponentContact"; 
import { Helmet } from "react-helmet";

  

function ContactUs() { 

  const backgroundImage12 = { 

    backgroundImage: `url(${joincomunity})`, 

    backgroundSize: "cover", 

    backgroundPosition: "center", 

    minHeight: "25vh", 

  

    marginTop: "10px", 

  }; 

  

  return (
    <>
      <Helmet>
        <title>Contact Us | CLOTA Technology</title>
        <meta
          name="description"
          content="Have questions or need assistance? Contact CLOTA Technology for support, inquiries, or consultations. We're here to help you."
        />
        <meta name="robots" content="index, follow" />
        <meta
          name="keywords"
          content="CLOTA contact, tech support, IT consultation, web development help, cloud services, software assistance"
        />
         <meta name="robots" content="index, follow" />
  <meta name="author" content="Clota Technology" />
  <link rel="canonical" href="https://www.clotatech.com/ContactUsForm" />
      </Helmet>
      {/* <div className="">
        <img
          src={Contactimg1}
          className="w-full h-auto homebanner"
          alt="Contact Us Banner"
        />
      </div> */}

      <div className="banner-container">
        <img src={Contactimg1} className="banner-image" alt="Banner" />

        {/* Centered Content */}
        <div className="banner-content">
          <div className="banner-text">
            <h1 className="banner-heading">Contact Us </h1>
            {/* <p>Apply Now!</p> */}
          </div>
        </div>
      </div>

      <br />

      <br />

      <div className="mt-5 px-5 py-2">
        <div className="flex flex-column align-items-start">
          <div className="HomeMission">
            <h3>
              <strong>Having doubts ? Feel free to Ask!!</strong>
            </h3>

            <br />

            <h5 className="contactheading">
              <strong>
                <i>Thank you for your interest in our services!!!</i>
              </strong>
            </h5>

            <p className="">
              <i>
                If you have any questions or queries a member of staff will
                always be happy to help. Feel free to contact us by telephone or
                email and so That way we have your contact information and can
                easily get back to you within a business day to schedule an
                introductory call. We will be sure to get back to you as soon as
                possible.
              </i>
            </p>

            <br />
          </div>
        </div>
      </div>

      {/* New current */}

      <div className="mt-5 px-5 py-2">
        <CommanComponentContact />
      </div>

      <br />

      {/* <div
        className="flex flex-column align-items-center justify-content-center text-center px-4"
        style={backgroundImage12}
      >
        <div className="col-12 text-center">
          <h1 style={{ color: "white", fontSize: "50px" }}>
            Join our community on Clota Forums
          </h1>

          <br />

          <p style={{ color: "white", fontSize: "22px" }}>
            We Design and Develop Experiences That Makes People Lives Simple.
          </p>
        </div>

        <br />

        <div className="mt-2 mb-2">
          <Link
            to="https://blog.clotatech.com/"
            style={{ textDecoration: "none" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="btn-styles btn btn-info">Connect Now</Button>
          </Link>
        </div>
      </div> */}

      <br />
    </>
  ); 

} 

  

export default ContactUs; 

 